import { render, staticRenderFns } from "./suggestionList.vue?vue&type=template&id=d3683914&scoped=true"
import script from "./suggestionList.vue?vue&type=script&lang=js"
export * from "./suggestionList.vue?vue&type=script&lang=js"
import style0 from "./suggestionList.vue?vue&type=style&index=0&id=d3683914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3683914",
  null
  
)

export default component.exports